import React from 'react'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import masterServices from '../../Services/masterService'
export function ProductDetail() {
    const history = useHistory()
    const [data,] = useState(history.location.state)
    // const [isDetailOpen, setIsDetailOpen] = useState([])

    let param = new URLSearchParams(history.location.search)

    useEffect(() => {
        onDetail()
        // eslint-disable-next-line
    }, [])

    const onDetail = () => {
        let postData = {
            id: param.get('id')

        }
        masterServices.get_warehouse_details(postData).then(res => {

            if (res.status) {
                // setIsDetailOpen(res.data)
            }
        })
    }
    return (

        <div className="container-fluid">
            <div className="white_box h-100">
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card p-3">
                                    <div className="row">
                                        <div className="col-lg-4 col-md-6 border-end">
                                            <table width="100%">
                                                <tbody>
                                                    <tr>
                                                        <td className="py-1">Product Name - </td>
                                                        <td className="py-1">{data.name}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Short Name - </td>
                                                        <td className="py-1">{data.short_name}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Adress - </td>
                                                        <td className="py-1">{data.address}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Ownership - </td>
                                                        <td className="py-1">{data.ownership}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1"> Remarks - </td>
                                                        <td className="py-1">{data.remarks}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Status - </td>
                                                        <td> <span className="badge rounded-pill font-size-12 pointer bg-success">{data.status}</span> </td>

                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}
